export default {
  mediaGallery: {
    crop: {
      title: 'Crop for gallery preview',
      profilePhotoTitle: 'Crop for your profile photo',
      coverPhotoTitle: 'Crop for your cover photo',
      subtitle: 'You can always view the actual size of photo by clicking and zooming it',
    },
    stubs: {
      smallGallery: 'Please add some photos to your gallery',
      files: 'Please add some files to your documents',
      bigGalleryTitle: 'PLEASE ADD SOME PICTURES TO YOUR GALLERY',
      bigGallerySubtitle: 'Add Pictures',
    },
    viewModal: {
      filePage: 'Page {{count1}} of {{count2}}',
    },
    errors: {
      fileWeight: 'The file may not be greater than 15 megabytes',
      fileType: 'Wrong file type',
      fileTypeItem: '{{fileName}} is of an unsupported type',
      maximumNumberOfFile: 'Maximum number of files added',
    },
    dateCreate: 'Date create',
  },
};
